export type FleetManagerWizardStep = "provider" | "fleets" | "values" | "install";

export const FLEET_MANAGER_WIZARD_STEPS: FleetManagerWizardStep[] = ["provider", "fleets", "values", "install"];
